import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const AssetFormBuy = ({
  catalogs = {},
  costCenters = [],
  errors = {},
  handleValueChange = () => {},
  isLoading = false,
  isSubmitted = false,
  providers = [],
  t = () => {},
  values = {},
}) => {
  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.buy')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._provider) || {}}
          name={'provider'}
          label={t('assets.fields.provider')}
          handleChange={handleValueChange}
          t={t}
          value={values._provider && values._provider.id}
        >
          {providers &&
            providers
              .filter((element) => element != null)
              .map((provider) => (
                <option value={provider.id} key={provider.id}>
                  {provider.key} - {provider.name}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.price) || {}}
          name={'price'}
          label={t('assets.fields.price') + ' * '}
          handleChange={handleValueChange}
          t={t}
          value={values.price}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._coin) || {}}
          isLoading={isLoading}
          name={'coin'}
          label={t('assets.fields.coin')}
          handleChange={handleValueChange}
          t={t}
          value={values._coin && values._coin.id}
        >
          {catalogs.coin &&
            catalogs.coin
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.exchange) || {}}
          name={'exchange'}
          label={t('assets.fields.exchange')}
          handleChange={handleValueChange}
          t={t}
          value={values.exchange}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._buyCondition) || {}}
          isLoading={isLoading}
          name={'buyCondition'}
          label={t('assets.fields.buyCondition')}
          handleChange={handleValueChange}
          t={t}
          value={values._buyCondition && values._buyCondition.id}
        >
          {catalogs.buyCondition &&
            catalogs.buyCondition
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._costCenter) || {}}
          isLoading={isLoading}
          name={'costCenter'}
          label={t('assets.fields.costCenter')}
          handleChange={handleValueChange}
          t={t}
          value={values._costCenter && values._costCenter.id}
        >
          {costCenters &&
            costCenters
              .filter((element) => element != null)
              .map((costCenter) => (
                <option value={costCenter.id} key={costCenter.id}>
                  {costCenter.key} - {costCenter.name}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.price) || {}}
          name={'dollarAssetPrice'}
          label={t('assets.fields.dollarAssetPrice')}
          handleChange={handleValueChange}
          t={t}
          value={values.dollarAssetPrice}
        />
      </div>
    </div>
  );
};

export default translate()(AssetFormBuy);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormBuy.js